import i18n from 'i18next';
import { initReactI18next } from "react-i18next";

// EN
import commonEN from './i18n/en/uni/common.json';
import commonEN_US from './i18n/en/us/common.json';
import commonEN_CA from './i18n/en/ca/common.json';
import menuEN from './i18n/en/uni/menu.json';
import mapManagementEN from './i18n/en/uni/mapManagement.json';
import mapManagementEN_US from './i18n/en/us/mapManagement.json';
import mapManagementEN_CA from './i18n/en/ca/mapManagement.json';
import dialogEN from './i18n/en/uni/dialog.json';
import editDriverEN from './i18n/en/uni/editDriver.json';
import parcelReturnEN from './i18n/en/uni/parcelReturn.json';
import editOrderEN from './i18n/en/uni/editOrder.json';
import batchManagementEN from './i18n/en/uni/batchManagement.json';
import storageScanEN from './i18n/en/uni/storageScan.json';
import secondDeliveryEN from './i18n/en/uni/secondDelivery.json';
import resendOrdersEN from './i18n/en/uni/resendOrders.json';
import helpDeskEN from './i18n/en/uni/helpDesk.json';
import podQualityManagementEN from './i18n/en/uni/podQualityManagement.json';
import etaDeliveryRateReportEN from './i18n/en/uni/etaDeliveryRateReport.json';
import complaintEN from './i18n/en/uni/complaint.json';
import quickTransferEN from './i18n/en/uni/quickTransfer.json';
import selfReturnEN from './i18n/en/uni/selfReturn.json';
import transferOrdersSubBatchEN from './i18n/en/uni/transferOrdersSubBatch.json';
import slotAssignmentEN from './i18n/en/uni/slotAssignment.json';
import holdingPackagesManagementEN from './i18n/en/uni/holdingPackagesManagement.json';
import orderStatusEN from './i18n/en/uni/orderStatus.json';
import driverDispatchEN from './i18n/en/uni/driverDispatch.json';
import scanReportEN from './i18n/en/uni/scanReport.json';
import updateToolboxEN from './i18n/en/uni/updateToolbox.json';
import uploadExcelEN from './i18n/en/uni/uploadExcel.json';
import advancedSearchEN from './i18n/en/uni/advancedSearch.json';
import lastStateStatisticsEN from './i18n/en/uni/lastStateStatistics.json';
import localDeliveryEN from './i18n/en/uni/localDelivery.json';
import workflowEN from './i18n/en/uni/workflowManagement.json';
import userManagementEN from './i18n/en/uni/userManagement.json';
import postalCodesExportEN from './i18n/en/uni/postalCodesExport.json';
import localDeliveryCountReportEN from './i18n/en/uni/localDeliveryCountReport.json';
import driverApprovalEN from './i18n/en/uni/driverApproval.json';
import driverApprovalEN_US from './i18n/en/us/driverApproval.json';
import driverApprovalEN_CA from './i18n/en/ca/driverApproval.json';
import preAlertQueryEN from './i18n/en/uni/preAlertManagement.json';
import incidentManagementEN from './i18n/en/uni/incidentManagement.json';
import deliveryAreaManagementEN from './i18n/en/uni/deliveryAreaManagement.json';
import driverPickupEN from './i18n/en/uni/driverPickup.json';
import wrongAddressToolEN from './i18n/en/uni/wrongAddressTool.json';
import wrongAddressToolZH from './i18n/zh-Hans/uni/wrongAddressTool.json';
import driverEfficiencyMonitorEN from './i18n/en/uni/driverEfficiencyMonitor.json';
import orderForwardToolEN from './i18n/en/uni/orderForwardTool.json';
import payrollAdjustmentEN from './i18n/en/uni/payrollAdjustment.json';
import messageCenterEN from './i18n/en/uni/messageCenter.json';
import selfPickupEN from './i18n/en/uni/selfPickup.json';
import orderExchangeEN from './i18n/en/uni/orderExchange.json';
import sortingMachineManagementEN from './i18n/en/uni/sortingMachineManagement.json';
import bbcOrderManagementEN from './i18n/en/uni/bbcOrderManagement.json';

// ZH
import commonZH from './i18n/zh-Hans/uni/common.json';
import commonZH_US from './i18n/zh-Hans/us/common.json';
import commonZH_CA from './i18n/zh-Hans/ca/common.json';
import menuZH from './i18n/zh-Hans/uni/menu.json';
import mapManagementZH from './i18n/zh-Hans/uni/mapManagement.json';
import mapManagementZH_US from './i18n/zh-Hans/us/mapManagement.json';
import mapManagementZH_CA from './i18n/zh-Hans/ca/mapManagement.json';
import dialogZH from './i18n/zh-Hans/uni/dialog.json';
import editDriverZH from './i18n/zh-Hans/uni/editDriver.json';
import parcelReturnZH from './i18n/zh-Hans/uni/parcelReturn.json';
import editOrderZH from './i18n/zh-Hans/uni/editOrder.json';
import batchManagementZH from './i18n/zh-Hans/uni/batchManagement.json';
import storageScanZH from './i18n/zh-Hans/uni/storageScan.json';
import secondDeliveryZH from './i18n/zh-Hans/uni/secondDelivery.json';
import resendOrdersZH from './i18n/zh-Hans/uni/resendOrders.json';
import helpDeskZH from './i18n/zh-Hans/uni/helpDesk.json';
import podQualityManagementZH from './i18n/zh-Hans/uni/podQualityManagement.json';
import etaDeliveryRateReportZH from './i18n/zh-Hans/uni/etaDeliveryRateReport.json';
import complaintZH from './i18n/zh-Hans/uni/complaint.json';
import quickTransferZH from './i18n/zh-Hans/uni/quickTransfer.json';
import selfReturnZH from './i18n/zh-Hans/uni/selfReturn.json';
import transferOrdersSubBatchZH from './i18n/zh-Hans/uni/transferOrdersSubBatch.json';
import slotAssignmentZH from './i18n/zh-Hans/uni/slotAssignment.json';
import holdingPackagesManagementZH from './i18n/zh-Hans/uni/holdingPackagesManagement.json';
import orderStatusZH from './i18n/zh-Hans/uni/orderStatus.json';
import driverDispatchZH from './i18n/zh-Hans/uni/driverDispatch.json';
import scanReportZH from './i18n/zh-Hans/uni/scanReport.json';
import updateToolboxZH from './i18n/zh-Hans/uni/updateToolbox.json';
import uploadExcelZH from './i18n/zh-Hans/uni/uploadExcel.json';
import advancedSearchZH from './i18n/zh-Hans/uni/advancedSearch.json';
import lastStateStatisticsZH from './i18n/zh-Hans/uni/lastStateStatistics.json';
import localDeliveryZH from './i18n/zh-Hans/uni/localDelivery.json';
import userManagementZH from './i18n/zh-Hans/uni/userManagement.json';
import postalCodesExportZH from './i18n/zh-Hans/uni/postalCodesExport.json';
import localDeliveryCountReportZH from './i18n/zh-Hans/uni/localDeliveryCountReport.json';
import driverApprovalZH from './i18n/zh-Hans/uni/driverApproval.json';
import driverApprovalZH_US from './i18n/zh-Hans/us/driverApproval.json';
import driverApprovalZH_CA from './i18n/zh-Hans/ca/driverApproval.json';
import preAlertQueryZH from './i18n/zh-Hans/uni/preAlertManagement.json';
import driverPickupZH from './i18n/zh-Hans/uni/driverPickup.json';
import driverEfficiencyMonitorZH from './i18n/zh-Hans/uni/driverEfficiencyMonitor.json';
import orderForwardToolZH from './i18n/zh-Hans/uni/orderForwardTool.json';
import payrollAdjustmentZH from './i18n/zh-Hans/uni/payrollAdjustment.json';
import messageCenterZH from './i18n/zh-Hans/uni/messageCenter.json';
import selfPickupZH from './i18n/zh-Hans/uni/selfPickup.json';
import orderExchangeZH from './i18n/zh-Hans/uni/orderExchange.json';
import sortingMachineManagementZH from './i18n/zh-Hans/uni/sortingMachineManagement.json';
import bbcOrderManagementZH from './i18n/zh-Hans/uni/bbcOrderManagement.json';

// FR
import commonFR from './i18n/fr/uni/common.json';
import commonFR_US from './i18n/fr/us/common.json';
import commonFR_CA from './i18n/fr/ca/common.json';
import menuFR from './i18n/fr/uni/menu.json';
import mapManagementFR from './i18n/fr/uni/mapManagement.json';
import mapManagementFR_US from './i18n/fr/us/mapManagement.json';
import mapManagementFR_CA from './i18n/fr/ca/mapManagement.json';
import dialogFR from './i18n/fr/uni/dialog.json';
import editDriverFR from './i18n/fr/uni/editDriver.json';
import parcelReturnFR from './i18n/fr/uni/parcelReturn.json';
import editOrderFR from './i18n/fr/uni/editOrder.json';
import batchManagementFR from './i18n/fr/uni/batchManagement.json';
import storageScanFR from './i18n/fr/uni/storageScan.json';
import secondDeliveryFR from './i18n/fr/uni/secondDelivery.json';
import resendOrdersFR from './i18n/fr/uni/resendOrders.json';
import helpDeskFR from './i18n/fr/uni/helpDesk.json';
import podQualityManagementFR from './i18n/fr/uni/podQualityManagement.json';
import etaDeliveryRateReportFR from './i18n/fr/uni/etaDeliveryRateReport.json';
import complaintFR from './i18n/fr/uni/complaint.json';
import quickTransferFR from './i18n/fr/uni/quickTransfer.json';
import selfReturnFR from './i18n/fr/uni/selfReturn.json';
import transferOrdersSubBatchFR from './i18n/fr/uni/transferOrdersSubBatch.json';
import slotAssignmentFR from './i18n/fr/uni/slotAssignment.json';
import holdingPackagesManagementFR from './i18n/fr/uni/holdingPackagesManagement.json';
import orderStatusFR from './i18n/fr/uni/orderStatus.json';
import driverDispatchFR from './i18n/fr/uni/driverDispatch.json';
import scanReportFR from './i18n/fr/uni/scanReport.json';
import updateToolboxFR from './i18n/fr/uni/updateToolbox.json';
import uploadExcelFR from './i18n/fr/uni/uploadExcel.json';
import advancedSearchFR from './i18n/fr/uni/advancedSearch.json';
import lastStateStatisticsFR from './i18n/fr/uni/lastStateStatistics.json';
import localDeliveryFR from './i18n/fr/uni/localDelivery.json';
import workflowFR from './i18n/fr/uni/workflowManagement.json';
import userManagementFR from './i18n/fr/uni/userManagement.json';
import postalCodesExportFR from './i18n/fr/uni/postalCodesExport.json';
import localDeliveryCountReportFR from './i18n/fr/uni/localDeliveryCountReport.json';
import driverApprovalFR from './i18n/fr/uni/driverApproval.json';
import driverApprovalFR_US from './i18n/fr/us/driverApproval.json';
import driverApprovalFR_CA from './i18n/fr/ca/driverApproval.json';
import preAlertQueryFR from './i18n/fr/uni/preAlertManagement.json';
import incidentManagementFR from './i18n/fr/uni/incidentManagement.json';
import deliveryAreaManagementFR from './i18n/fr/uni/deliveryAreaManagement.json';
import driverPickupFR from './i18n/fr/uni/driverPickup.json';
import payrollAdjustmentFR from './i18n/fr/uni/payrollAdjustment.json';
import selfPickupFR from './i18n/fr/uni/selfPickup.json';
import orderExchangeFR from './i18n/fr/uni/orderExchange.json';

import { getLanguagePref } from './utilities/language';

const resources = {
    "fr": {
        orderExchange: orderExchangeFR,
        common: commonFR,
        menu: menuFR,
        mapManagement: mapManagementFR,
        dialog: dialogFR,
        editDriver: editDriverFR,
        parcelReturn: parcelReturnFR,
        editOrder: editOrderFR,
        batchManagement: batchManagementFR, 
        storageScan: storageScanFR,
        secondDelivery: secondDeliveryFR,
        resendOrders: resendOrdersFR,
        helpDesk: helpDeskFR,
        quickTransfer: quickTransferFR,
        selfReturn: selfReturnFR,
        slotAssignment: slotAssignmentFR,
        transferOrdersSubBatch: transferOrdersSubBatchFR,
        holdingPackagesManagement: holdingPackagesManagementFR,
        orderStatus: orderStatusFR,
        driverDispatch: driverDispatchFR,
        scanReport: scanReportFR,
        complaint: complaintFR,
        etaDeliveryRateReport: etaDeliveryRateReportFR,
        updateToolbox: updateToolboxFR,
        uploadExcel: uploadExcelFR,
        advancedSearch: advancedSearchFR,
        lastStateStatistics: lastStateStatisticsFR,
        localDelivery: localDeliveryFR,
        workflowManagement: workflowFR,
        userManagement: userManagementFR,
        postalCodesExport: postalCodesExportFR,
        localDeliveryCountReport: localDeliveryCountReportFR,
        driverApproval: driverApprovalFR,
        preAlertManagement: preAlertQueryFR,
        incidentManagement: incidentManagementFR,
        driverPickup: driverPickupFR,
        podQualityManagement: podQualityManagementFR,
        deliveryAreaManagement: deliveryAreaManagementFR,
        payrollAdjustment: payrollAdjustmentFR,
        selfPickup: selfPickupFR
    },
    "en": {
        orderExchange: orderExchangeEN,
        common: commonEN,
        menu: menuEN,
        mapManagement: mapManagementEN,
        dialog: dialogEN,
        editDriver: editDriverEN,
        parcelReturn: parcelReturnEN,
        editOrder: editOrderEN,
        batchManagement: batchManagementEN, 
        storageScan: storageScanEN,
        secondDelivery: secondDeliveryEN,
        resendOrders: resendOrdersEN,
        helpDesk: helpDeskEN,
        quickTransfer: quickTransferEN,
        selfReturn: selfReturnEN,
        slotAssignment: slotAssignmentEN,
        transferOrdersSubBatch: transferOrdersSubBatchEN,
        holdingPackagesManagement: holdingPackagesManagementEN,
        orderStatus: orderStatusEN,
        driverDispatch: driverDispatchEN,
        scanReport: scanReportEN,
        complaint: complaintEN,
        etaDeliveryRateReport: etaDeliveryRateReportEN,
        updateToolbox: updateToolboxEN,
        uploadExcel: uploadExcelEN,
        advancedSearch: advancedSearchEN,
        lastStateStatistics: lastStateStatisticsEN,
        localDelivery: localDeliveryEN,
        workflowManagement: workflowEN,
        userManagement: userManagementEN,
        postalCodesExport: postalCodesExportEN,
        localDeliveryCountReport: localDeliveryCountReportEN,
        driverApproval: driverApprovalEN,
        preAlertManagement: preAlertQueryEN,
        incidentManagement: incidentManagementEN,
        driverPickup: driverPickupEN,
        podQualityManagement: podQualityManagementEN,
        deliveryAreaManagement: deliveryAreaManagementEN,
        wrongAddressTool: wrongAddressToolEN,
        driverEfficiencyMonitor:driverEfficiencyMonitorEN,
        payrollAdjustment: payrollAdjustmentEN,
        messageCenter: messageCenterEN,
        orderForwardTool: orderForwardToolEN,
        payrollAdjustment: payrollAdjustmentEN,
        selfPickup: selfPickupEN,
        sortingMachineManagement: sortingMachineManagementEN,
        bbcOrderManagement: bbcOrderManagementEN
    },
    "zh-Hans": {
        orderExchange: orderExchangeZH,
        common: commonZH,
        menu: menuZH,
        mapManagement: mapManagementZH,
        dialog: dialogZH,
        editDriver: editDriverZH,
        parcelReturn: parcelReturnZH,
        editOrder: editOrderZH,
        batchManagement: batchManagementZH, 
        storageScan: storageScanZH,
        secondDelivery: secondDeliveryZH,
        resendOrders: resendOrdersZH,
        helpDesk: helpDeskZH,
        quickTransfer: quickTransferZH,
        selfReturn: selfReturnZH,
        slotAssignment: slotAssignmentZH,
        transferOrdersSubBatch: transferOrdersSubBatchZH,
        holdingPackagesManagement: holdingPackagesManagementZH,
        orderStatus: orderStatusZH,
        driverDispatch: driverDispatchZH,
        scanReport: scanReportZH,
        complaint: complaintZH,
        etaDeliveryRateReport: etaDeliveryRateReportZH,
        updateToolbox: updateToolboxZH,
        uploadExcel: uploadExcelZH,
        advancedSearch: advancedSearchZH,
        lastStateStatistics: lastStateStatisticsZH,
        localDelivery: localDeliveryZH,
        userManagement: userManagementZH,
        postalCodesExport: postalCodesExportZH,
        localDeliveryCountReport: localDeliveryCountReportZH,
        driverApproval: driverApprovalZH,
        preAlertManagement: preAlertQueryZH,
        incidentManagement: incidentManagementEN,
        driverPickup: driverPickupZH,
        podQualityManagement: podQualityManagementZH,
        deliveryAreaManagement: deliveryAreaManagementEN,
        wrongAddressTool: wrongAddressToolZH,
        driverEfficiencyMonitor:driverEfficiencyMonitorZH,
        payrollAdjustment:payrollAdjustmentZH,
        messageCenter: messageCenterZH,
        orderForwardTool: orderForwardToolZH,
        payrollAdjustment: payrollAdjustmentZH,
        selfPickup: selfPickupZH,
        sortingMachineManagement: sortingMachineManagementZH,
        bbcOrderManagement: bbcOrderManagementZH
    },
    "fr-US": {
        common: commonFR_US,
        mapManagement: mapManagementFR_US,
        driverApproval: driverApprovalFR_US
    },
    "en-US": {
        common: commonEN_US,
        mapManagement: mapManagementEN_US,
        driverApproval: driverApprovalEN_US
    },
    "zh-US": {
        common: commonZH_US,
        mapManagement: mapManagementZH_US,
        driverApproval: driverApprovalZH_US
    },
    "fr-CA": {
        common: commonFR_CA,
        mapManagement: mapManagementFR_CA,
        driverApproval: driverApprovalFR_CA
    },
    "en-CA": {
        common: commonEN_CA,
        mapManagement: mapManagementEN_CA,
        driverApproval: driverApprovalEN_CA
    },
    "zh-CA": {
        common: commonZH_CA,
        mapManagement: mapManagementZH_CA,
        driverApproval: driverApprovalZH_CA
    }
}

i18n
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: {
            'fr-US': ['fr'],
            'en-US': ['en'],
            'zh-US': ['zh-Hans'],
            'fr-CA': ['en'],
            'en-CA': ['en'],
            'zh-CA': ['zh-Hans'],
            'default': ['en', 'zh-Hans', 'fr'] 
        },
        lng: getLanguagePref(),
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;